import LuigisBoxPageViewLists from '~/models/LuigisBox/LuigisBoxPageViewLists'
import LuigisBoxFilters from '~/models/LuigisBox/LuigisBoxFilters'
import LuigisBoxPageView from '~/models/LuigisBox/LuigisBoxPageView'
import LuigisBoxItem from '~/models/LuigisBox/LuigisBoxItem'
import { LuigisBoxEventType } from '~/models/LuigisBox/LuigisBoxEventType'
import LuigisBoxAction from '~/models/LuigisBox/LuigisBoxAction'
import useLuigisBoxClientIdCookie from '~/composables/useLuigisBoxClientIdCookie'
import useLuigisBoxCookie from '~/composables/useLuigisBoxCookie'

export default class LuigisBoxEventApi {
    static API_URL = 'https://api.luigisbox.com/'

    static sendRequest(
        eventType: LuigisBoxEventType,
        lists: LuigisBoxPageViewLists | null = null,
        action: LuigisBoxAction | null = null
    ): void {
        setTimeout(() => {
            const config = useRuntimeConfig()
            const route = useRoute()
            const inputData: LuigisBoxPageView = {
                type: eventType,
                tracker_id: config.public.luigisboxTrackerId,
                client_id: LuigisBoxEventApi.getClientId(),
                consent_granted: true,
                local_timestamp: Math.round(Date.now() / 1000),
                app_version: 'fc3a4bd7',
                id: LuigisBoxEventApi.generateUniqueIdentifier(),
                url: `${config.public.apiUrl}${route.fullPath}`,
                path: `${route.path}`,
                title: document.title,
                referer: document.referrer,
            }
            if (action !== null) {
                inputData.action = action
            }
            if (lists !== null) {
                inputData.lists = lists
            }

            const eventApiMode = config.public.luigisboxEventApiMode
            if (eventApiMode === 'log') {
                console.log('luigisbox event API', inputData)
            } else if (eventApiMode === 'api') {
                $fetch(LuigisBoxEventApi.API_URL, {
                    method: 'POST',
                    body: inputData,
                })
            }
        }, 0)
    }

    static sendPageView(): void {
        LuigisBoxEventApi.sendRequest('pv')
    }

    static sendSearchPageView(queryString: string, items: LuigisBoxItem[], filters: LuigisBoxFilters): void {
        filters._SearchVariant = 'Original'
        LuigisBoxEventApi.sendRequest('pv', {
            'Search Results': {
                items,
                query: { string: queryString, filters },
            },
        })
    }

    static sendAutocompleteEvent(queryString: string, items: LuigisBoxItem[]): void {
        const filters = {
            _SearchVariant: 'Original',
        }
        LuigisBoxEventApi.sendRequest('event', {
            Autocomplete: {
                items,
                query: { string: queryString, filters },
            },
        })
    }

    static sendRecommendationEvent(
        items: LuigisBoxItem[],
        title: string,
        type: 'last_seen' | 'homepage_trends' | 'item_detail',
        itemIds: string | null = null
    ): void {
        const filters: LuigisBoxFilters = {
            Context: title,
            Recommender: type,
            RecommenderClientId: `${type}_original`,
            Type: type,
            _Variant: 'Original',
        }
        if (itemIds) {
            filters.ItemIds = itemIds
        }
        LuigisBoxEventApi.sendRequest('event', {
            Recommendation: {
                items,
                query: { filters },
            },
        })
    }

    static sendClickEvent(clickType: 'click' | 'add-to-cart' | 'add-to-wishlist' | 'buy', resourceIdentifier: string | number): void {
        const action = {
            type: clickType,
            resource_identifier: resourceIdentifier,
        } as LuigisBoxAction
        LuigisBoxEventApi.sendRequest('click', null, action)
    }

    static getClientId(): number {
        const cookie = useLuigisBoxClientIdCookie()
        if (!cookie.value) {
            cookie.value = `${LuigisBoxEventApi.generateUniqueIdentifier()}`
        }

        useLuigisBoxCookie().value = cookie.value

        return parseInt(cookie.value)
    }

    static generateUniqueIdentifier(): number {
        return Math.floor(new Date().getTime() / 1e3) * Math.pow(2, 32) + Math.round(Math.random() * (Math.pow(2, 31) - 1))
    }
}
